// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tree-single-text {
  background: #f7f9fd;
  border-radius: 4px;
  line-height: 1;
  margin: 8px 10px 0;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 7px;
  white-space: nowrap;
  color: #333;
}
.tree-single-text .unselect {
  color: #999;
}
.refer-search-box {
  padding: 10px 10px 12px;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
          align-items: center;
}
.refer-search-box .refer-search-input {
  width: 300px;
}
.refer-search-box .refer-search-backbtn {
  margin-left: 10px;
}
.refer-search-box .refer-search-checkbox {
  margin-left: 10px;
}
.refer-search-box .dropdown-btn {
  margin-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ReferInputPcNew/components/ReferSearch/index.less"],"names":[],"mappings":"AAGA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AAFF;AAPA;EAYI,WAAA;AAFJ;AAMA;EACE,uBAAA;EACA,qBAAA;EAAA,aAAA;EACA,2BAAA;UAAA,mBAAA;AAJF;AACA;EAMI,YAAA;AAJJ;AAFA;EAUI,iBAAA;AALJ;AALA;EAcI,iBAAA;AANJ;AARA;EAkBI,gBAAA;AAPJ","sourcesContent":["\n\n\n.tree-single-text {\n  background: #f7f9fd;\n  border-radius: 4px;\n  line-height: 1;\n  margin: 8px 10px 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 7px;\n  white-space: nowrap;\n  color: #333;\n\n  .unselect {\n    color: #999;\n  }\n}\n\n.refer-search-box {\n  padding: 10px 10px 12px;\n  display: flex;\n  align-items: center;\n\n  .refer-search-input {\n    width: 300px;\n  }\n\n  .refer-search-backbtn {\n    margin-left: 10px;\n  }\n\n  .refer-search-checkbox {\n    margin-left: 10px;\n  }\n\n  .dropdown-btn {\n    margin-left: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
